import { SelectedFilterInterface } from "../../interfaces/productRange/SelectedFilterInterface";

export const hasSelectedFilters = (
    selectedFilters: Record<number, SelectedFilterInterface>,
): boolean => Object.keys(selectedFilters).length > 0;

export const buildProductRangeOptionsQuery = (
    selectedFilters: Record<number, SelectedFilterInterface>,
): string | undefined => {
    const optionIds = Object.values(selectedFilters).flatMap(
        (filter) => filter.options ?? [],
    );

    if (optionIds.length === 0) {
        return undefined;
    }

    return optionIds.join(",");
};
